.container {
    height: 600px;
    background-color: #1C1D25;
}

.contentContainer {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

/* out of the flow, so the logo stays in the center */
.toTop {
    position: absolute;
    left: 100%;
    margin-top: 15px;
    margin-left: 12px;
    white-space: nowrap;
    transition: 0.4s;
    opacity: 0;
    transform: translateX(-25px);
    color: white;
}

.iconLink {
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
}

.iconLink:hover .toTop {
    opacity: 1;
    transform: translateX(0);
}

.linkContainer {
    margin-top: 30px;
}

.license {
    color: gray;
}

.licenceContainer {
    margin-top: 40px;
}

.contact {
    color: inherit;
}

@media (max-width: 768px) {
    .linkContainer {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 18px;
    }
}
